/*
SaiKrishna 10/06/2022 3075154998 Removed unnecessary console.log statements
Suresh Peddavoora 10/28/2022 3075154998  Added Class Name for Text Fields and Buttons
 Lalitha          11/9/2022  3075154998 Rename Button Cancel to Reset
*/
import React, {useEffect, useContext} from 'react';
import {Formik} from 'formik';
import {Button, Grid, TextField} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import * as Yup from 'yup';
import {getDropDownData} from '../../../../../../redux/reducers/EnableFramework/Filter';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';

const ConditionForm = ({
  setConditionData,
  conditionData,
  setFilterOpen,
  handleConditionClose,
  conditionRowData,
  isConditionEditMode,
  setIsConditionEditMode,
  conditionCode,
  ruleGroupSNo,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  let initialValues = {
    code: isConditionEditMode ?
      conditionRowData && conditionRowData.code :
      ruleGroupSNo ?
        ruleGroupSNo > 9 ?
          'R' + ruleGroupSNo :
          'R0' + ruleGroupSNo :
        isConditionEditMode && conditionRowData && conditionRowData.code ?
          conditionRowData.code :
          '',
    conditionOperator:
      isConditionEditMode && conditionRowData?.conditionOperator ?
        conditionRowData?.conditionOperator :
        '',
    fieldOne: isConditionEditMode && conditionRowData?.fieldOne ? conditionRowData?.fieldOne : '',
    fieldCode:
      isConditionEditMode && conditionRowData?.fieldCode ? conditionRowData?.fieldCode : '',
    srcField: isConditionEditMode && conditionRowData?.srcField ? conditionRowData?.srcField : '',
    fieldFormat:
      isConditionEditMode && conditionRowData?.fieldFormat ? conditionRowData?.fieldFormat : '',
  };
  // const [currentRuleCode, setCurrentRuleCode] = useState(conditionRowData?.code || '');
  const currentRuleCode = conditionRowData?.code || '';

  useEffect(() => {
    initialValues = {
      code: isConditionEditMode ?
        conditionRowData && conditionRowData.code :
        ruleGroupSNo ?
          ruleGroupSNo > 9 ?
            'R' + ruleGroupSNo :
            'R0' + ruleGroupSNo :
          isConditionEditMode && conditionRowData && conditionRowData.code ?
            conditionRowData.code :
            '',
      conditionOperator:
        isConditionEditMode && conditionRowData?.conditionOperator ?
          conditionRowData?.conditionOperator :
          '',
      toField: isConditionEditMode && conditionRowData?.toField ? conditionRowData?.toField : '',
      fieldCode:
        isConditionEditMode && conditionRowData?.fieldCode ? conditionRowData?.fieldCode : '',
      srcField: isConditionEditMode && conditionRowData?.srcField ? conditionRowData?.srcField : '',
      fieldFormat:
        isConditionEditMode && conditionRowData?.fieldFormat ? conditionRowData?.fieldFormat : '',
    };
  }, [conditionRowData]);
  const fieldFormatOptions = [
    {key: 'MDY', value: 'MDY'},
    {key: 'YMD', value: 'YMD'},
  ];

  const handleSubmit = (data) => {
    const copiedData = [...conditionData];
    if (!isConditionEditMode) {
      copiedData.push({...data});
      setConditionData(copiedData);
      setFilterOpen(false);
    } else {
      const updatedActionData = copiedData.map((item, i) => {
        if (i === conditionCode) {
          return {
            ...item,
            code: data?.code,
            conditionOperator: data?.conditionOperator,
            fieldName: data?.fieldName,
            fieldCode: data?.fieldCode,
            dateorField: data?.dateorField,
            fieldFormat: data?.fieldFormat,
            seqNo: i + 1,
            srcField: data.srcField,
            toField: data?.toField,
          };
        } else {
          return {...item};
        }
      });
      setConditionData(updatedActionData);
      setFilterOpen(false);
      setIsConditionEditMode(false);
    }
  };
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  const schema = Yup.object().shape({
    code:
      conditionRowData?.code === currentRuleCode && isConditionEditMode ?
        '' :
        Yup.string()
          .notOneOf(
            conditionData.map((data) => data.code),
            'Rule code already exists',
          )
          .required('Rule Code is required').nullable(),
  });
  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            handleChange,
            handleSubmit,
            handleReset,
            handleBlur,
            setFieldValue,
          } = props;
          return (
            <div>
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div className="global-field-textfields">
                  <Grid container spacing={2}>
                    <Grid item xs={6} className="form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder="Enter To Field"
                        label="To Field"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="fieldOne"
                        value={values.fieldOne}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Expression`}
                        label="Expression"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="conditionOperator"
                        value={values.conditionOperator}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6} className="form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="fieldFormat"
                        id="fieldFormat"
                        size="small"
                        value={values.fieldFormat}
                        options={fieldFormatOptions.map((item) => item.value)}
                        onChange={(e, value) => {
                          setFieldValue('fieldFormat', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params} // Spread the properties from params to GuiTextField intentionally.
                              variant="outlined"
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              margin="dense"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Date Format"
                              placeholder="Select Date Format"
                            />
                          </div>
                        )}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className="text-center">
                  <div className="row justify-content-center mb-1">
                    <Button
                      type="button"
                      onClick={() => handleReset()}
                      variant="outlined"
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default ConditionForm;
